<template>
  <div class="tpp-page">
    <nearby-housekeeping-ops-nav active-path="/pages/tpp/nearby-housekeeping/workbench" :platform-id="platformId" />
    <section class="tpp-panel">
      <div class="tpp-panel__head">
        <div>
          <h2 class="tpp-panel__title">附近家政概览</h2>
          <p class="tpp-muted">{{ platform.platformName || '附近家政' }} · {{ platform.platformCode || 'NEARBY_HOUSEKEEPING' }} · {{ platform.platformStatus || '-' }}</p>
        </div>
        <el-button size="small" icon="el-icon-refresh" :loading="loading" @click="load">刷新</el-button>
      </div>
      <el-alert :title="healthText" :type="healthy ? 'success' : 'warning'" :closable="false" show-icon />
    </section>
    <section class="tpp-panel" v-loading="loading">
      <div class="tpp-card-grid">
        <div class="tpp-stat-card" @click="goNearby('/pages/tpp/nearby-housekeeping/payments')"><span>生效收款</span><strong>{{ display(summary.activeBindingCount) }}</strong></div>
        <div class="tpp-stat-card" @click="goNearby('/pages/tpp/nearby-housekeeping/product-changes')"><span>待复核</span><strong>{{ display(summary.openReviewCount) }}</strong></div>
        <div class="tpp-stat-card" @click="goNearby('/pages/tpp/nearby-housekeeping/refunds')"><span>退款单</span><strong>{{ display(summary.refundCount) }}</strong></div>
      </div>
      <h3 class="tpp-panel__title" style="margin-top:16px">接入配置（只读）</h3>
      <el-descriptions :column="1" border size="small">
        <el-descriptions-item label="当前环境">{{ access.environment || '-' }}</el-descriptions-item>
        <el-descriptions-item label="配置中心 HC_ENV">{{ access.hcEnv || access.environment || '-' }}</el-descriptions-item>
        <el-descriptions-item label="API 基址">{{ access.baseUrl || '-' }}</el-descriptions-item>
        <el-descriptions-item label="微信 app_id">{{ channelAppId('wechat') }}</el-descriptions-item>
        <el-descriptions-item label="元服务 app_id">{{ channelAppId('meta') }}</el-descriptions-item>
      </el-descriptions>
      <h3 class="tpp-panel__title" style="margin-top:16px">回调地址</h3>
      <el-descriptions :column="1" border size="small">
        <el-descriptions-item label="订单回调">{{ url('orderStatus') }}</el-descriptions-item>
        <el-descriptions-item label="商品变更回调">{{ url('productChange') }}</el-descriptions-item>
        <el-descriptions-item label="退款回调">{{ url('refundStatus') }}</el-descriptions-item>
      </el-descriptions>
      <p class="tpp-tip">众合凭据由配置文件管理；TEST/PROD 由配置中心 ENV_DOMAIN/HC_ENV 决定。平台编码使用 NEARBY_HOUSEKEEPING。</p>
    </section>
  </div>
</template>
<script>
import NearbyHousekeepingOpsNav from './nearbyHousekeepingNav.vue'
import { nearbyHousekeepingOpsMixin } from './nearbyHousekeepingOpsMixin'
import { getNearbyHousekeepingSummary, nhPayload } from '@/api/tpp/nearbyHousekeepingOpsApi'
import '../tpp.scss'
export default {
  name: 'NearbyHousekeepingWorkbench',
  components: { NearbyHousekeepingOpsNav },
  mixins: [nearbyHousekeepingOpsMixin],
  data() { return { loading: false, summary: {} } },
  computed: {
    healthy() { return this.summary.health && this.summary.health.healthy },
    healthText() { return (this.summary.health && this.summary.health.message) || '正在检查协议模块' },
    access() { return this.summary.accessConfig || {} }
  },
  async created() { if (await this.ensureNearbyHousekeepingPlatform()) this.load() },
  methods: {
    display(value) { return value == null ? '-' : value },
    url(key) { return (this.summary.callbackUrls && this.summary.callbackUrls[key]) || '-' },
    channelAppId(key) {
      const channel = this.access[key]
      return (channel && (channel.appId || channel.merchantCode)) || '-'
    },
    async load() {
      this.loading = true
      try { this.summary = nhPayload(await getNearbyHousekeepingSummary({ platformId: this.platformId })) || {} }
      catch (e) { this.$message.error(e.message || '概览加载失败') }
      finally { this.loading = false }
    }
  }
}
</script>
<style scoped>
.tpp-stat-card { cursor: pointer; }
</style>
